import CaregiverResult from 'generated/Result/Caregiver/Models/CaregiverResult';
import { GET_CAREGIVER_PROFILE, RESET_CAREGIVER_PROFILE } from '../types/caregiver';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface CaregiverState {
  caregiverProfile: CaregiverResult
}

const INITIAL_STATE = {
  caregiverProfile: null,
} as CaregiverState;

const caregiverReducer = function (state = INITIAL_STATE, action: PayloadAction<CaregiverResult>): CaregiverState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_CAREGIVER_PROFILE:
      return { ...state, caregiverProfile: action.payload };
    case RESET_CAREGIVER_PROFILE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default caregiverReducer;
